import {
	createHistoryRouter,
	createRoute,
	createRouterControls,
	RouteInstance,
	RouteParams,
} from 'atomic-router';
import { createBrowserHistory } from 'history';
import { USER_ROLES, UserRole } from 'shared/api';
import {
	composeChains,
	createChainAuthorized,
	createChainUnauthorized,
	createChainRoles,
} from './guards';

export const loginRoute = createRoute();

export const accountsRoute = createRoute();

export const accountRoute = createRoute();

export const usersRoute = createRoute();

export const userRoute = createRoute<{ id: number }>();

export const cashdesksRoute = createRoute();

export const cashdeskRoute = createRoute<{ id: number }>();

export const gameSettingsRoute = createRoute();

export const reviewReportRoute = createRoute();

export const dailyReportRoute = createRoute();

export const detailedReportRoute = createRoute();

export const accountsReportRoute = createRoute();

export const shiftsReportRoute = createRoute();

export const sessionsReportRoute = createRoute();

export const devicesReportRoute = createRoute();

export const shiftsRoute = createRoute();

export const gamesRoute = createRoute();

export const gameRoute = createRoute();

export const jackpotsRoute = createRoute();

export const bonusesRoute = createRoute();

export const notFoundRoute = createRoute();

const chainAuthorized = createChainAuthorized({
	unauthorizedRedirect: loginRoute,
});

const ROLE_REDIRECTS = {
	[USER_ROLES.god]: accountsRoute,
	[USER_ROLES.admin]: accountsRoute,
	[USER_ROLES.cashier]: shiftsRoute,
} satisfies Record<UserRole, RouteInstance<RouteParams>>;

const chainUnauthorized = createChainUnauthorized({
	authorizedRedirects: ROLE_REDIRECTS,
});

const chainAdmin = createChainRoles({
	roles: [USER_ROLES.god, USER_ROLES.admin],
	forbiddenRedirects: ROLE_REDIRECTS,
});

const chainCashier = createChainRoles({
	roles: [USER_ROLES.cashier],
	forbiddenRedirects: ROLE_REDIRECTS,
});

const chainNobody = createChainRoles({
	roles: [],
	forbiddenRedirects: ROLE_REDIRECTS,
});

const chainAuthorizedAdmin = composeChains(chainAuthorized, chainAdmin);

const chainAuthorizedCashier = composeChains(chainAuthorized, chainCashier);

const chainAuthorizedNobody = composeChains(chainAuthorized, chainNobody);

export const authorizedLoginRoute = chainUnauthorized(loginRoute);

export const authorizedAccountsRoute = chainAuthorizedAdmin(accountsRoute);

export const authorizedAccountRoute = chainAuthorizedAdmin(accountRoute);

export const authorizedUsersRoute = chainAuthorizedAdmin(usersRoute);

export const authorizedUserRoute = chainAuthorizedAdmin(userRoute);

export const authorizedCashdesksRoute = chainAuthorizedAdmin(cashdesksRoute);

export const authorizedCashdeskRoute = chainAuthorizedAdmin(cashdeskRoute);

export const authorizedGamesRoute = chainAuthorizedAdmin(gamesRoute);

export const authorizedGameSettingsRoute = chainAuthorizedAdmin(gameSettingsRoute);

export const authorizedReviewReportRoute = chainAuthorizedAdmin(reviewReportRoute);

export const authorizedDailyReportRoute = chainAuthorizedAdmin(dailyReportRoute);

export const authorizedDetailedReportRoute = chainAuthorizedAdmin(detailedReportRoute);

export const authorizedAccountsReportRoute = chainAuthorizedAdmin(accountsReportRoute);

export const authorizedShiftsReportRoute = chainAuthorizedAdmin(shiftsReportRoute);

export const authorizedSessionsReportRoute = chainAuthorizedAdmin(sessionsReportRoute);

export const authorizedDevicesReportRoute = chainAuthorizedAdmin(devicesReportRoute);

export const authorizedShiftsRoute = chainAuthorizedCashier(shiftsRoute);

export const authorizedGameRoute = chainAuthorizedCashier(gameRoute);

export const authorizedNotFoundRoute = chainAuthorizedNobody(notFoundRoute);

export const authorizedJackpotsRoute = chainAuthorizedAdmin(jackpotsRoute);

export const authorizedBonusesRoute = chainAuthorizedAdmin(bonusesRoute);

export const controls = createRouterControls();

export const router = createHistoryRouter({
	routes: [
		{
			path: '/login',
			route: loginRoute,
		},
		{
			path: '/accounts',
			route: accountsRoute,
		},
		{
			path: '/accountancy',
			route: accountRoute,
		},
		{
			path: '/users',
			route: usersRoute,
		},
		{
			path: '/jackpots',
			route: jackpotsRoute,
		},
		{
			path: '/bonuses',
			route: bonusesRoute,
		},
		{
			path: '/users/:id',
			route: userRoute,
		},
		{
			path: '/cashdesks',
			route: cashdesksRoute,
		},
		{
			path: '/cashdesks/:id',
			route: cashdeskRoute,
		},
		{
			path: '/games',
			route: gamesRoute,
		},
		{
			path: '/game-settings',
			route: gameSettingsRoute,
		},
		{
			path: '/reports/review',
			route: reviewReportRoute,
		},
		{
			path: '/reports/daily',
			route: dailyReportRoute,
		},
		{
			path: '/reports/detailed',
			route: detailedReportRoute,
		},
		{
			path: '/reports/accounts',
			route: accountsReportRoute,
		},
		{
			path: '/reports/shifts',
			route: shiftsReportRoute,
		},
		{
			path: '/reports/sessions',
			route: sessionsReportRoute,
		},
		{
			path: '/reports/devices',
			route: devicesReportRoute,
		},
		{
			path: '/shifts',
			route: shiftsRoute,
		},
		{
			path: '/game',
			route: gameRoute,
		},
	],
	notFoundRoute,
	controls,
});

router.setHistory(createBrowserHistory());
